<h1>Environment Sync</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a
    mat-tab-link
    *ngFor="let tab of tabs"
    (click)="onTabSelected(tab)"
    [active]="tab.id === activeTab?.id"
    >{{ tab.title }}</a
  >
</nav>
<mat-tab-nav-panel #tabPanel>
  <div *ngIf="activeTab">
    <div class="sync-header">
      <h2>{{ activeTab.title }}</h2>
      <div class="sync-description-wrapper">
        <p>
          Compare and synchronize {{ activeTab.title.toLowerCase() }} data between QA and Production
          environments.
        </p>
        <div class="sync-action-buttons">
          <button mat-raised-button color="primary" (click)="loadSchemasForActiveTab()">
            <mat-icon>refresh</mat-icon>
            Refresh Data
          </button>
          <button
            mat-raised-button
            color="accent"
            (click)="pushSelectedChanges()"
            [disabled]="!isPushEnabled()"
          >
            <mat-icon>sync</mat-icon>
            Push to Production
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="env-sync-content">
      <div *ngIf="isLoading" class="sync-loading-indicator">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading data from QA and Production environments...</p>
      </div>
      <div *ngIf="!isLoading && !schemas?.length" class="sync-no-data-message">
        <p>No data available for comparison.</p>
      </div>
      <app-schema-comparison
        *ngIf="!isLoading && schemas?.length"
        [schemas]="schemas"
      ></app-schema-comparison>
    </div>
  </div>
</mat-tab-nav-panel>
